import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { toast } from "sonner";
import { Download, Copy, Printer, MessageCircle, Link2 } from "lucide-react";

export function QRCard({ event, link, studioName }) {
  const wrapRef = useRef(null);
  const studio = studioName || event.photographer_name;

  const downloadPng = () => {
    const canvas = wrapRef.current?.querySelector("canvas");
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `PMR-${event.name.replace(/\s/g, "-")}-QR.png`;
    a.click();
    toast.success("QR code downloaded");
  };
  const copyLink = () => { navigator.clipboard.writeText(link); toast.success("Event link copied"); };
  const whatsapp = () => window.open(`https://wa.me/?text=${encodeURIComponent(`View & select your photos from "${event.name}": ${link}`)}`, "_blank");
  const print = () => {
    const canvas = wrapRef.current?.querySelector("canvas");
    const img = canvas?.toDataURL("image/png");
    const w = window.open("", "_blank");
    w.document.write(`<html><head><title>PMR Events — ${event.name}</title><style>
      body{margin:0;font-family:'Outfit',sans-serif;background:#0a0a0a;color:#fff;display:flex;align-items:center;justify-content:center;height:100vh}
      .card{width:360px;text-align:center;border:1px solid #d4af37;border-radius:24px;padding:40px 30px;background:#0a0a0a}
      h1{font-family:Georgia,serif;font-weight:400;font-size:28px;margin:0 0 4px}
      .t{color:#d4af37;font-size:11px;letter-spacing:3px;text-transform:uppercase}
      img{width:220px;height:220px;background:#fff;padding:12px;border-radius:16px;margin:20px 0}
      .s{color:#a3a3a3;font-size:13px}</style></head>
      <body><div class="card"><div class="t">PMR Events</div>${studio ? `<div style="color:#e8d6a8;font-size:13px;margin-bottom:6px">${studio}</div>` : ""}<h1>${event.name}</h1>
      <img src="${img}"/><div class="s">Scan to find your photos</div></div>
      <script>window.onload=()=>{window.print()}</script></body></html>`);
    w.document.close();
  };

  return (
    <div className="rounded-2xl border border-border bg-black/40 p-6">
      <div ref={wrapRef} className="mx-auto w-fit">
        <div className="rounded-3xl border border-gold/30 p-8 text-center bg-gradient-to-b from-gold/5 to-transparent max-w-xs">
          <div className="text-[10px] uppercase tracking-[0.3em] text-gold">PMR Events</div>
          {studio && <div className="text-xs text-maroon font-medium mt-1">{studio}</div>}
          <div className="font-serif text-2xl text-white mt-1 leading-tight">{event.name}</div>
          <div className="bg-white p-3 rounded-2xl inline-block mt-5">
            <QRCodeCanvas value={link} size={180} level="M" fgColor="#0a0a0a" bgColor="#ffffff" />
          </div>
          <div className="text-sm text-muted-foreground mt-4">Scan to find your photos</div>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mt-6">
        <button data-testid="qr-download" onClick={downloadPng} className="flex items-center justify-center gap-2 glass rounded-xl py-2.5 text-sm text-white hover:border-gold/40"><Download className="w-4 h-4" /> PNG</button>
        <button data-testid="qr-print" onClick={print} className="flex items-center justify-center gap-2 glass rounded-xl py-2.5 text-sm text-white hover:border-gold/40"><Printer className="w-4 h-4" /> Print</button>
        <button data-testid="qr-copy" onClick={copyLink} className="flex items-center justify-center gap-2 glass rounded-xl py-2.5 text-sm text-white hover:border-gold/40"><Copy className="w-4 h-4" /> Copy</button>
        <button data-testid="qr-whatsapp" onClick={whatsapp} className="flex items-center justify-center gap-2 glass rounded-xl py-2.5 text-sm text-white hover:border-gold/40"><MessageCircle className="w-4 h-4" /> Share</button>
      </div>
      <div className="mt-4 flex items-center gap-2 rounded-xl bg-secondary border border-input px-3 py-2.5">
        <Link2 className="w-4 h-4 text-muted-foreground shrink-0" />
        <span className="text-xs text-secondary-foreground truncate flex-1">{link}</span>
      </div>
    </div>
  );
}
